import { render } from "./FormPacienteDependente.vue?vue&type=template&id=f691cc90&scoped=true"
import script from "./FormPacienteDependente.vue?vue&type=script&lang=js"
export * from "./FormPacienteDependente.vue?vue&type=script&lang=js"

import "./FormPacienteDependente.vue?vue&type=style&index=0&id=f691cc90&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f691cc90"]])

export default __exports__